import * as React from 'react';

const PrinterFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="printer-fill_svg__eds-icon--printer-fill_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="printer-fill_svg__eds-icon--printer-fill_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 7v10h4v4h12v-4h4V7H2zm5 6h10v7H7v-7z"
        />
        <path
            id="printer-fill_svg__eds-icon--printer-fill_top"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 6V5h10v1h1V4H6v2z"
        />
        <g
            id="printer-fill_svg__eds-icon--printer-fill_lines"
            fillRule="evenodd"
            clipRule="evenodd"
        >
            <path d="M8 15h8v1H8zM8 17h8v1H8z" />
        </g>
    </svg>
);

PrinterFillSvg.displayName = 'PrinterFillSvg';
export default PrinterFillSvg;
